var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cont-itensAtencao flexC-base"},[(_vm.alerta.tipo === 'cliente')?_c('alerta-cliente',{attrs:{"alerta":_vm.alerta}}):_vm._e(),(_vm.alerta.tipo === 'lance')?_c('alerta-lance',{attrs:{"alerta":_vm.alerta}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }